import { create } from 'zustand';

// Minimal UI-facing progress state for the local-first BSB hydration
// (M.3.6.3.b). Mirrors the sync-store pattern: a tiny dedicated slice
// kept separate from the main app store so hydration concerns do not
// entangle with prayer / settings flows.
//
// `bootstrapProgress` is a normalized 0..1 value updated as books
// stream in. The reverent indicator does NOT render the number; it
// only listens to `isBibleBootstrapping` to decide visibility, gated
// by a 500ms render delay so fast hydrations never flash UI.
// `bootstrapBooksDone` / `bootstrapBooksTotal` (2026-08-25) back the
// truthful "N of 66 saved" line on the Bible index. On the resumable
// first-hydration path, `done` seeds from the checkpoint inventory so a
// resumed run reads "18 of 66", never a reset-to-zero lie. UI gates on
// `isBibleBootstrapping && bootstrapBooksTotal > 0`.
interface BibleBootstrapState {
  isBibleBootstrapping: boolean;
  bootstrapProgress: number;
  bootstrapBooksDone: number;
  bootstrapBooksTotal: number;
  setBibleBootstrapping: (value: boolean) => void;
  setBootstrapProgress: (value: number) => void;
  setBootstrapCounts: (done: number, total: number) => void;
}

export const useBibleBootstrapStore = create<BibleBootstrapState>((set) => ({
  isBibleBootstrapping: false,
  bootstrapProgress: 0,
  bootstrapBooksDone: 0,
  bootstrapBooksTotal: 0,
  setBibleBootstrapping: (value) => set({ isBibleBootstrapping: value }),
  setBootstrapProgress: (value) => set({ bootstrapProgress: value }),
  setBootstrapCounts: (done, total) =>
    set({ bootstrapBooksDone: done, bootstrapBooksTotal: total }),
}));
